module.exports = __webpack_public_path__ + "img/submit_code.b87354bd.png";